import React from 'react';
import {FormattedMessage} from 'react-intl';
import {RouterLinkButton} from '../../../components/button/button';
import {useErrorMessagesDispatch} from '../error-messages-context';
import ArrowRightIcon from '../../../assets/icons0/arrow-right.svg';
import useImpulseService from './use-impulse-service';


const useInvalidEndpoints = ({serviceId}) => {
    const errorDispatch = useErrorMessagesDispatch();
    const [invalidEndpoints, setInvalidEndpoints] = React.useState([]);
    const {serviceUrl} = useImpulseService({serviceId});

    const addInvalidEndpoint = React.useCallback((item) => {
        setInvalidEndpoints(state => [...state, item]);
    }, [setInvalidEndpoints]);

    const resetInvalidEndpoints = React.useCallback(() => {
        setInvalidEndpoints([]);
    }, [setInvalidEndpoints]);
    
    React.useEffect(() => {
        if (invalidEndpoints.length > 0) {
            errorDispatch({
                type: 'add',
                payload: {
                    type: 'lightError',
                    title: <FormattedMessage defaultMessage='There are unavailable tickets in the order'/>,
                    description: <FormattedMessage defaultMessage='To place an order, return to the event page and select available tickets'/>,
                    showDefaultAction: false,
                    action: <RouterLinkButton {...{to: serviceUrl, plain: true, color: 'error'}}><span className='padding-right-0dot5rem'><FormattedMessage defaultMessage='To event'/></span><ArrowRightIcon className='display-block width-1dot25rem height-1dot25rem'/></RouterLinkButton>
                }
            });
        }
    }, [invalidEndpoints]);

    return (
        {
            invalidEndpoints,
            addInvalidEndpoint,
            resetInvalidEndpoints
        }
    );
};

export default useInvalidEndpoints;
